import { render, staticRenderFns } from "./RubikPatterns.vue?vue&type=template&id=7a30704a&scoped=true&lang=pug"
import script from "./RubikPatterns.vue?vue&type=script&lang=js"
export * from "./RubikPatterns.vue?vue&type=script&lang=js"
import style0 from "./RubikPatterns.vue?vue&type=style&index=0&id=7a30704a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a30704a",
  null
  
)

export default component.exports